import { StyleSheet, Platform } from "react-native";
export default StyleSheet.create({
  container: {
    alignItems: "center",
    marginTop: 5,
    marginBottom: 10
  },
  wrapper: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#b2b2b2",
    borderRadius: 15,
    height: 30,
    paddingLeft: 10,
    paddingRight: 10
  },
  text: {
    backgroundColor: "transparent",
    color: "#fff",
    fontSize: 12
  },
  activityIndicator: {
    marginTop: Platform.select({
      ios: -14,
      android: -16
    })
  }
});